<!--
  Order artifact (WB-7401). Two states share one card shell so the transition from
  "creating" to "created" doesn't shift the surrounding timeline layout.
-->

<!-- ── Creation in progress ──────────────────────────────────────────────────── -->
<div class="order-artifact order-artifact--creating" *ngIf="state === 'creating'" data-testid="order-artifact-creating">
    <div class="order-artifact__header">
        <span class="order-artifact__icon order-artifact__icon--ai">
            <ui-svg-icon svgIcon="sparkle" size="medium"></ui-svg-icon>
        </span>
        <div class="order-artifact__header-main">
            <div class="order-artifact__title-row">
                <span class="order-artifact__title">{{ 'smart_inbox.order_artifact.creating_title' | translate }}</span>
                <span class="order-artifact__ellipsis" aria-hidden="true">
                    <span></span><span></span><span></span>
                </span>
            </div>
            <span class="volta-skel order-artifact__skel order-artifact__skel--subtitle"></span>
        </div>
        <span class="volta-skel order-artifact__skel order-artifact__skel--header-action"></span>
    </div>

    <table class="order-artifact__table" aria-hidden="true">
        <thead>
            <tr>
                <th class="order-artifact__col-product">{{ 'smart_inbox.order_artifact.columns.product' | translate }}</th>
                <th class="order-artifact__col-sku">{{ 'smart_inbox.order_artifact.columns.sku' | translate }}</th>
                <th class="order-artifact__col-qty">{{ 'smart_inbox.order_artifact.columns.qty' | translate }}</th>
                <th class="order-artifact__col-price">{{ 'smart_inbox.order_artifact.columns.price' | translate }}</th>
                <th class="order-artifact__col-total">{{ 'smart_inbox.order_artifact.columns.total' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of skeletonRows">
                <td class="order-artifact__col-product"><span class="volta-skel order-artifact__skel order-artifact__skel--product"></span></td>
                <td class="order-artifact__col-sku"><span class="volta-skel order-artifact__skel order-artifact__skel--sku"></span></td>
                <td class="order-artifact__col-qty"><span class="volta-skel order-artifact__skel order-artifact__skel--qty"></span></td>
                <td class="order-artifact__col-price"><span class="volta-skel order-artifact__skel order-artifact__skel--price"></span></td>
                <td class="order-artifact__col-total"><span class="volta-skel order-artifact__skel order-artifact__skel--price"></span></td>
            </tr>
        </tbody>
    </table>

    <div class="order-artifact__footer">
        <span class="volta-skel order-artifact__skel order-artifact__skel--footer-left"></span>
        <span class="volta-skel order-artifact__skel order-artifact__skel--footer-right"></span>
    </div>
</div>

<!-- ── Order created ─────────────────────────────────────────────────────────── -->
<ng-container *ngIf="state === 'created'">
<div class="order-artifact" *ngIf="order as timelineOrder" [attr.data-testid]="'order-artifact-' + timelineOrder.order.id">
    <div class="order-artifact__header">
        <span class="order-artifact__icon">
            <ui-svg-icon svgIcon="cart" size="medium"></ui-svg-icon>
        </span>
        <div class="order-artifact__header-main">
            <div class="order-artifact__title-row">
                <button
                    type="button"
                    class="order-artifact__title order-artifact__title--link"
                    (click)="onOpenOrder($event)">
                    <span class="order-artifact__title-prefix">{{ 'smart_inbox.inbox_view.detail.order_pill' | translate }}</span>
                    <span class="order-artifact__title-id">{{ timelineOrder.order.name }}</span>
                </button>
                <!-- Revealed on hover of the whole card header (see the SCSS). -->
                <ui-copyable
                    class="order-artifact__copy"
                    size="big"
                    [value]="timelineOrder.order.name"
                    [label]="'smart_inbox.order_artifact.order_id_label' | translate">
                </ui-copyable>
            </div>
            <div class="order-artifact__customer">
                <span
                    class="order-artifact__customer-chip"
                    *ngIf="!isCustomerMissing"
                    [matTooltip]="companyName"
                    matTooltipClass="conversation-tooltip-info">
                    <ui-svg-icon svgIcon="shop" size="small"></ui-svg-icon>
                    <span class="order-artifact__customer-name">{{ companyName }}</span>
                </span>
                <!-- An order with no customer cannot be completed — flag it in amber. -->
                <span
                    class="order-artifact__customer-chip order-artifact__customer-chip--missing"
                    *ngIf="isCustomerMissing"
                    [matTooltip]="'smart_inbox.order_artifact.missing_customer_tooltip' | translate"
                    matTooltipClass="conversation-tooltip-info">
                    <ui-svg-icon svgIcon="shop" size="small"></ui-svg-icon>
                    <span class="order-artifact__customer-name">{{ 'smart_inbox.order_artifact.missing_customer' | translate }}</span>
                </span>
            </div>
        </div>
        <span class="order-artifact__last-modified" *ngIf="lastModifiedAt">
            {{ 'smart_inbox.order_artifact.last_modified' | translate }}
            {{ lastModifiedAt | daysAgoOrLeft: 'ago' : 2 : 'DD/MM/YYYY HH:mm' }}
        </span>
    </div>

    <table class="order-artifact__table">
        <thead>
            <tr>
                <th class="order-artifact__col-product">{{ 'smart_inbox.order_artifact.columns.product' | translate }}</th>
                <th class="order-artifact__col-sku">{{ 'smart_inbox.order_artifact.columns.sku' | translate }}</th>
                <th class="order-artifact__col-qty">{{ 'smart_inbox.order_artifact.columns.qty' | translate }}</th>
                <ng-container *ngIf="!hidePricingColumns">
                    <th class="order-artifact__col-price">{{ 'smart_inbox.order_artifact.columns.price' | translate }}</th>
                    <th class="order-artifact__col-total">{{ 'smart_inbox.order_artifact.columns.total' | translate }}</th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <!-- Only reached on the legacy-payload path, where lines are fetched separately. -->
            <ng-container *ngIf="linesLoading">
                <tr *ngFor="let row of skeletonRows">
                    <td class="order-artifact__col-product"><span class="volta-skel order-artifact__skel order-artifact__skel--product"></span></td>
                    <td class="order-artifact__col-sku"><span class="volta-skel order-artifact__skel order-artifact__skel--sku"></span></td>
                    <td class="order-artifact__col-qty"><span class="volta-skel order-artifact__skel order-artifact__skel--qty"></span></td>
                    <ng-container *ngIf="!hidePricingColumns">
                        <td class="order-artifact__col-price"><span class="volta-skel order-artifact__skel order-artifact__skel--price"></span></td>
                        <td class="order-artifact__col-total"><span class="volta-skel order-artifact__skel order-artifact__skel--price"></span></td>
                    </ng-container>
                </tr>
            </ng-container>

            <tr
                *ngFor="let line of lines"
                class="order-artifact__row"
                (click)="onOpenOrder($event)">
                <td class="order-artifact__col-product" [matTooltip]="line.product_name" matTooltipClass="conversation-tooltip-info">
                    <!-- Same icon the side-by-side marks these rows with, so the
                         two surfaces read as one feature. -->
                    <ui-svg-icon
                        *ngIf="line.unmatched"
                        class="order-artifact__unmatched-icon"
                        svgIcon="unmatched-icon"
                        size="small"
                        [matTooltip]="'smart_inbox.order_artifact.unmatched_line' | translate"
                        matTooltipClass="conversation-tooltip-info"></ui-svg-icon>
                    {{ line.product_name }}
                </td>
                <td class="order-artifact__col-sku">{{ line.sku || '--' }}</td>
                <td class="order-artifact__col-qty">
                    <span class="order-artifact__qty-value">{{ getQuantityLabel(line) }}</span>
                    <span class="order-artifact__qty-unit" *ngIf="getQuantityUnit(line) as unit">{{ unit }}</span>
                    <span class="order-artifact__qty-unit" *ngIf="!getQuantityUnit(line)">
                        {{ 'quotations_and_orders.side_by_side_panel.units_suffix' | translate }}
                    </span>
                </td>
                <ng-container *ngIf="!hidePricingColumns">
                    <!-- Null check, not truthiness: a free line is priced 0, not unpriced. -->
                    <td class="order-artifact__col-price">{{ line.final_price != null ? (line.final_price | number: '1.2-2') + ' ' + currencySymbol : '--' }}</td>
                    <td class="order-artifact__col-total">{{ line.total != null ? (line.total | number: '1.2-2') + ' ' + currencySymbol : '--' }}</td>
                </ng-container>
            </tr>

            <tr class="order-artifact__row order-artifact__row--empty" *ngIf="!linesLoading && !lines.length">
                <td [attr.colspan]="hidePricingColumns ? 3 : 5">
                    {{ (linesLoadFailed ? 'smart_inbox.order_artifact.lines_load_failed' : 'smart_inbox.order_artifact.no_lines') | translate }}
                </td>
            </tr>
        </tbody>
    </table>

    <!--
        WB-7569: with pricing hidden and no `+N more` link this strip has nothing
        to render — collapse it instead of leaving an empty banded row.
    -->
    <div class="order-artifact__summary" *ngIf="showSummaryRow">
        <button
            type="button"
            class="order-artifact__more-link"
            *ngIf="hiddenLinesCount > 0"
            (click)="onOpenOrder($event)">
            {{ 'smart_inbox.order_artifact.more_items' | translate: { count: hiddenLinesCount } }}
        </button>
        <span class="order-artifact__summary-spacer"></span>
        <span class="order-artifact__total" *ngIf="showOrderTotal">
            <ng-container *ngIf="allLinesNoPrice; else totalValue">
                {{ 'quotations_and_orders.price_source_none' | translate }}
            </ng-container>
            <ng-template #totalValue>
                {{ currencyCode }} {{ total | number: '1.2-2' }}
            </ng-template>
        </span>
    </div>

    <div class="order-artifact__footer">
        <div class="order-artifact__status" [ngStyle]="getStatusStyles(currentStatus)">
            {{ 'quotations_and_orders.QuotationStatus.' + currentStatus | translate }}
        </div>

        <div class="order-artifact__footer-actions">
            <button
                type="button"
                class="order-artifact__icon-btn"
                [matTooltip]="'smart_inbox.order_artifact.tooltip_preview' | translate"
                matTooltipClass="conversation-tooltip-info"
                (click)="onOpenOrder($event)">
                <ui-svg-icon svgIcon="eye" size="small"></ui-svg-icon>
            </button>

            <!--
                Same main action the order-detail header offers for this status.
                Uses `ui-button type="primary"` so it is the exact same size as the
                "Create order" button in the conversation action bar.
            -->
            <!-- Replaces the main action while the order still needs a human:
                 unresolved rows, no company or no location. -->
            <ui-button
                *ngIf="needsReview; else primaryActionButton"
                class="order-artifact__primary-action"
                type="primary"
                [label]="'smart_inbox.order_artifact.review_order' | translate"
                testId="order-artifact-review-btn"
                (click)="onReview($event)">
            </ui-button>

            <ng-template #primaryActionButton>
                <ng-container *ngIf="primaryAction as action">
                    <ui-button
                        class="order-artifact__primary-action"
                        type="primary"
                        [label]="action.labelKey | translate"
                        (click)="onPrimaryAction($event)"
                        *appHasPermission="action.permission">
                    </ui-button>
                </ng-container>
            </ng-template>

            <button
                type="button"
                class="order-artifact__icon-btn"
                [matMenuTriggerFor]="orderArtifactMenu"
                (click)="$event.stopPropagation()">
                <ui-svg-icon svgIcon="more_horiz" size="small"></ui-svg-icon>
            </button>

            <!-- Uses the shared `ui-action-menu` / `ui-action-menu-item` convention
                 (src/styles/ui/menu/_menu.scss) so the destructive entry is styled
                 from a global stylesheet — the menu renders in a body-level overlay
                 that component-scoped SCSS cannot reach. -->
            <mat-menu #orderArtifactMenu="matMenu" class="ui-action-menu">
                <button mat-menu-item type="button" class="ui-action-menu-item" (click)="onViewFullOrder($event)">
                    <span class="ui-action-menu-item__label">{{ 'smart_inbox.order_artifact.menu.view_full_order' | translate }}</span>
                </button>
                <button mat-menu-item type="button" class="ui-action-menu-item" (click)="onDownloadPdf($event)">
                    <span class="ui-action-menu-item__label">{{ 'quotations_and_orders.download_pdf' | translate }}</span>
                </button>
                <button mat-menu-item type="button" class="ui-action-menu-item" (click)="onDownloadCsv($event)">
                    <span class="ui-action-menu-item__label">{{ 'quotations_and_orders.download_csv' | translate }}</span>
                </button>
                <ng-container *ngIf="canCancel">
                    <button
                        mat-menu-item
                        type="button"
                        class="ui-action-menu-item"
                        (click)="onSecondaryAction('cancel_order', $event)"
                        *appHasPermission="{ module: 'order', action: 'edit' }">
                        <span class="ui-action-menu-item__label">{{ 'common.cancel' | translate }}</span>
                    </button>
                </ng-container>
                <button
                    mat-menu-item
                    type="button"
                    class="ui-action-menu-item"
                    (click)="onSecondaryAction('duplicate_order', $event)"
                    *appHasPermission="{ module: 'order', action: 'edit' }">
                    <span class="ui-action-menu-item__label">{{ 'quotations_and_orders.actions.duplicate' | translate }}</span>
                </button>
                <ng-container *ngIf="canDelete">
                    <button
                        mat-menu-item
                        type="button"
                        class="ui-action-menu-item ui-action-menu-item--danger"
                        (click)="onSecondaryAction('delete_order', $event)"
                        *appHasPermission="{ module: 'order', action: 'delete' }">
                        <span class="ui-action-menu-item__icon">
                            <ui-svg-icon svgIcon="trash-cc" size="small"></ui-svg-icon>
                        </span>
                        <span class="ui-action-menu-item__label">{{ 'smart_inbox.order_artifact.menu.delete_order' | translate }}</span>
                    </button>
                </ng-container>
            </mat-menu>
        </div>
    </div>
</div>
</ng-container>
